const todoManager = {}

todoManager.count = (todoList) => {
  let complete = 0
  let incomplete = 0
  for (let i = 0; i < todoList.length; i++) {
    if (todoList[i].isDone) {
      complete++
    } else {
      incomplete++
    }
  }
  let sum = incomplete + complete
  return {complete: complete, incomplete: incomplete, sum: sum}
}

todoManager.obj2list = (todoObj) => {
  let todoList = []
  // Listへ
  Object.keys(todoObj).forEach((key) => {
    let obj = todoObj[key]
    obj.key = key
    todoList.push(obj)
  })

  // 表示順にソート
  todoList.sort((a, b) => {
    return (a.displayNum < b.displayNum ? -1 : 1)
  })

  return todoList
}

export default todoManager
